import { MISSIONS_STATES } from '../constants/missionsInfo';
export default function notificationCalculator() {
  var missions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var battlesCurrentCycle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var battlesCount = typeof battlesCurrentCycle.cycleGames === 'number' && typeof battlesCurrentCycle.gamesPlayed === 'number' ? Math.max(battlesCurrentCycle.cycleGames - battlesCurrentCycle.gamesPlayed, 0) : 0;
  var missionsCount = Array.isArray(missions) ? missions.slice(1).filter(function (mission) {
    return [MISSIONS_STATES.READY, MISSIONS_STATES.RUNNING, MISSIONS_STATES.LOCKED].includes(mission.missionStatus);
  }).length : 0;
  return {
    battlesCount: battlesCount,
    missionsCount: missionsCount
  };
}